module.exports = __webpack_public_path__ + "img/project-cover2.b63c38e3.png";